import { createFileRoute } from '@tanstack/react-router';
import { WebhooksPage } from '../../features/settings/components/webhooks-page.js';

export const Route = createFileRoute('/admin/webhooks')({ component: WebhooksPage });
